import { getNavStorage } from "@/utils/navigation";
import { ReactNode, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children: ReactNode;
  className?: string;
  aside?: ReactNode;
  stickySidebar?: boolean;
};

const PageContent = ({
  children,
  className,
  aside,
  stickySidebar = true,
}: Props) => {
  const navStorage = getNavStorage();
  const [expanded, setExpanded] = useState(
    navStorage.hasOwnProperty("expanded") ? navStorage.expanded : true,
  );

  const toggleExpanded = ({ detail }: any) => setExpanded(detail);

  useEffect(() => {
    document.addEventListener("menu-expanded", toggleExpanded);

    return () => document.removeEventListener("menu-expanded", toggleExpanded);
  }, []);

  return (
    <div
      className={twMerge(
        // spacing 18 is our topbar in PageHeader & 28 is the height of our Title in PageHeader
        // This calculation is optimistic but works for the cases where it is needed
        "column-up-left min-h-[calc(100vh-(--spacing(18))-(--spacing(28)))] w-full gap-4",
      )}
    >
      <div
        className={twMerge(
          "flex w-full flex-1 flex-col items-center",
          className,
        )}
      >
        <div
          className={twMerge(
            "flex w-full max-w-[1980px] flex-row items-start gap-2",
            !aside && "grow", // this makes sure our AG Grid's can fill out the space when no aside is present
          )}
        >
          <div
            className="flex h-full w-full flex-1 flex-col gap-2"
            data-testid="page-content"
          >
            {children}
          </div>
          {aside && (
            <div
              className={twMerge(
                "scrollbar-background w-84 rounded text-sm",
                stickySidebar &&
                  "sticky top-14 h-[calc(100vh-210px)] overflow-y-auto",
              )}
              data-testid="page-sidebar"
            >
              {aside}
            </div>
          )}
        </div>
      </div>
      {/* <div
        className={twMerge(
          "transition-[width] duration-300 bg-green-700s rounded",
          !expanded && "lg:w-[72px]",
          expanded && "w-0 xl:w-32 2xl:w-64",
        )}
      ></div> */}
    </div>
  );
};

export default PageContent;
